export const communityQueryKeys = {
  posts: (communityId: string | number) => [
    'community',
    Number(communityId),
    'posts',
  ],
  post: (communityId: string | number, postId: string) => [
    'community',
    Number(communityId),
    'posts',
    postId,
  ],
  postComments: (communityId: string | number, postId: string) => [
    'community',
    Number(communityId),
    'posts',
    postId,
    'comments',
  ],
};
